import type { PublicPageGuideStep } from "@/types";

export const getCalendarPageGuideStorageKey = (tenantSlug: string): string =>
  `te_calendar_guide_${tenantSlug}_v1`;

export const CALENDAR_PAGE_LEDE =
  "Agenda pública para pedir un horario en este espacio. Los bloques ocupados no están disponibles para pre-reservar; la sala se comunicará con vos por whatsapp para confirmar tu reserva después de enviarla.";

export const CALENDAR_PAGE_GUIDE_TITLE = "¿Cómo reservo un horario?";

export const CALENDAR_PAGE_GUIDE_INTRO =
  "Navegá la agenda, elegí un horario libre y mandá una pre-reserva con tus datos de contacto.";

export const CALENDAR_PAGE_GUIDE_STEPS: readonly PublicPageGuideStep[] = [
  {
    icon: "calendar",
    title: "Navegá la agenda",
    body: "Usá la barra superior para cambiar de semana o mes y ubicarte en el período que te interesa. Podés tocar fechas desde la vista mensual para ver sus horarios disponibles.",
  },
  {
    icon: "send",
    title: "Elegí un horario libre",
    body: "En la vista de horarios, sostené presionado y arrastrá para seleccionar un espacio vacío, hacé doble tap en la selección para pre-reservarlo.",
  },
  {
    icon: "message",
    title: "Enviá la pre-reserva",
    body: "Completá tu nombre y WhatsApp. La pre-reserva es una solicitud: la sala te contactará para confirmarlo como reserva.",
  },
] as const;

export const CALENDAR_PAGE_GUIDE_CONFIRM_LABEL = "Listo, ver agenda";

export const CALENDAR_PAGE_GUIDE_ACTION_TRACK_SUFFIX = "calendar_guide_dismiss";
